'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Drawers = function () {
  function Drawers(el) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Drawers);

    this.els = {
      el: el,
      body: document.body,
      backdrop: (0, _functional.getElement)('.js-Drawers_Backdrop')
    };
    this.matches = {
      trigger: '[data-module-drawers-trigger]',
      triggerToggle: '[data-module-drawers-trigger-toggle]',
      close: '[data-module-drawers-close]',
      backdrop: '.js-Drawers_Backdrop'
    };
    this.classes = {
      activeClass: 'drw-Drawers-active',
      activeDrawerClass: 'drw-Drawer-active',
      siteOverflowed: 'util-SiteOverflowed',
      bodyActiveClass: 'drw-DrawerIsActive'
    };
    this._activeDrawerKey = '';
    this.foundDrawers = (0, _functional.getElements)(this.matches.trigger).reduce(function (acc, el) {
      var key = el.dataset.moduleDrawersTrigger;
      acc[key] = _this.buildDrawer(key, el);

      return acc;
    }, {});

    this.setupListeners();

    window.drawers = this;
  }

  (0, _createClass3.default)(Drawers, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this2 = this;

      this.els.body.addEventListener('click', function (e) {
        var target = e.target;

        if (target.closest(_this2.matches.trigger) === false && target.closest(_this2.matches.close) === false && target.closest(_this2.matches.backdrop) === false) {
          return;
        }

        if (target.closest(_this2.matches.trigger)) {
          e.preventDefault();
          var matches = target.closest(_this2.matches.trigger);
          var key = matches.dataset.moduleDrawersTrigger;

          if (key in _this2.foundDrawers === false || key in _this2.foundDrawers && _this2.drawerIsComplete(key) === false) {
            _this2.foundDrawers[key] = _this2.buildDrawer(key, matches);
          }

          _this2.activeDrawerKey = key;

          if (target.matches.triggerToggle) {
            matches.dataset.moduleDrawersTriggerToggleState = 'open';
          }

          if (_this2.activeDrawerKey === 'cart') {
            var pushcartOpened = new CustomEvent('pushcartOpened');
            window.dispatchEvent(pushcartOpened);
          }

          if (_this2.activeDrawerKey === 'mobile-filters') {
            _this2.els.body.classList.add('drw-DrawerFilterIsActive');
          }
        }

        if (target.closest(_this2.matches.triggerToggle)) {
          e.preventDefault();
          var _matches = target.closest(_this2.matches.triggerToggle);
          var _key = _matches.dataset.moduleDrawersTriggerToggle;

          if (_key in _this2.foundDrawers === false || _key in _this2.foundDrawers && _this2.drawerIsComplete(_key) === false) {
            _this2.foundDrawers[_key] = _this2.buildDrawer(_key, _matches);
          }

          var isCurrentlyClosed = _matches.dataset.moduleDrawersTriggerToggleState === 'closed';
          _this2.activeDrawerKey = isCurrentlyClosed ? _key : '';

          _matches.dataset.moduleDrawersTriggerToggleState = isCurrentlyClosed ? 'open' : 'closed';
        }

        if (target.closest(_this2.matches.close)) {
          _this2.activeDrawerKey = '';
          _this2.els.body.classList.remove('drw-DrawerFilterIsActive');
        }

        if (target.closest(_this2.matches.backdrop)) {
          _this2.activeDrawerKey = '';
          _this2.els.body.classList.remove('drw-DrawerFilterIsActive');
        }
      });

      this.els.body.addEventListener('click', function (evt) {
        var target = evt.target;


        var isItem = target.closest('[data-menu-drawer-item]');
        var isBack = target.closest('[data-menu-drawer-back]');

        if (isBack) {
          var parent = target.closest('[data-menu-drawer-drawer]');
          var itemsParent = target.closest('[data-menu-drawer-items]');

          itemsParent.setAttribute('aria-selected', 'false');
          parent.setAttribute('aria-selected', 'false');
        } else if (isItem) {
          var _itemsParent = isItem.closest('[data-menu-drawer-items]');
          var drawer = (0, _functional.getElement)('[data-menu-drawer-drawer]', {
            context: isItem
          });

          _itemsParent.setAttribute('aria-selected', 'true');
          drawer.setAttribute('aria-selected', 'true');
        }
      });
    }
  }, {
    key: 'buildDrawer',
    value: function buildDrawer(key, matches) {
      var trigger = matches;
      var drawer = (0, _functional.getElement)('[data-module-drawers-drawer="' + key + '"]');
      var close = (0, _functional.getElement)('[data-module-drawers-close="' + key + '"]');

      var obj = {
        trigger: trigger,
        drawer: drawer,
        close: close,
        dynamicFromTop: drawer.hasAttribute('data-module-drawers-dynamic-top')
      };

      var activeClass = drawer.getAttribute('data-module-drawers-active-class');

      if (activeClass) {
        obj.activeClass = activeClass;
      }

      return obj;
    }
  }, {
    key: 'drawerIsComplete',
    value: function drawerIsComplete(key) {
      return (0, _values2.default)(this.foundDrawers[key]).filter(function (val) {
        return val != null;
      }).length === 0;
    }
  }, {
    key: 'activeDrawerKey',
    get: function get() {
      return this._activeDrawerKey;
    },
    set: function set(val) {
      var _this3 = this;

      this._activeDrawerKey = val;

      var hasActiveDrawerKey = val !== '';

      this.els.body.classList.toggle(this.classes.siteOverflowed, hasActiveDrawerKey);
      this.els.body.classList.toggle(this.classes.bodyActiveClass, hasActiveDrawerKey);
      this.els.el.classList.toggle(this.classes.activeClass, hasActiveDrawerKey);

      (0, _entries2.default)(this.foundDrawers).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        var activeClass = 'activeClass' in value ? value.activeClass : _this3.classes.activeDrawerClass;

        value.drawer.classList.toggle(activeClass, key === val);
      });

      // Close all open triggers
      (0, _functional.getElements)('[data-module-drawers-trigger-toggle-state="open"]').forEach(function (el) {
        el.dataset.moduleDrawersTriggerToggleState = 'closed';
      });
      (0, _functional.getElements)('[aria-selected="true"]').forEach(function (el) {
        el.setAttribute('aria-selected', false);
      });
    }
  }]);
  return Drawers;
}();

exports.default = Drawers;